interface IndexItem {
  letter: string;
  name: string;
  count: number;
}

const indexData: IndexItem[] = [
  { letter: 'A', name: '暗黑童话', count: 1 },
  { letter: 'H', name: '花间辞', count: 1 },
  { letter: 'J', name: '剑道独尊', count: 1 },
  { letter: 'L', name: '恋爱百分百 · 邻家天使', count: 2 },
  { letter: 'M', name: '末日生存指南', count: 1 },
  { letter: 'W', name: '我的温柔暴君 · 武林神话', count: 2 },
  { letter: 'X', name: '星界纹章 · 仙王的日常生活', count: 2 },
  { letter: 'Y', name: '妖怪公寓', count: 1 },
  { letter: 'Z', name: '重生之都市修仙', count: 1 },
];

export default function Index() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">
          漫画索引
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-8 md:mb-10">
          按字母快速检索站内漫画作品
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 max-w-4xl mx-auto">
          {indexData.map((item) => (
            <a
              key={item.letter}
              href="#cards"
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-200 hover:bg-primary-50/20 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex-shrink-0 rounded-lg bg-primary-100 flex items-center justify-center">
                <span className="font-heading text-lg sm:text-xl font-bold text-primary-600">
                  {item.letter}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.name}
                </h3>
              </div>
              <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full flex-shrink-0">
                {item.count}部
              </span>
            </a>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <div className="flex flex-wrap justify-center gap-1.5">
            {['A','B','C','D','E','F','G','H','J','K','L','M','N','P','Q','R','S','T','W','X','Y','Z'].map((letter) => (
              <a
                key={letter}
                href="#index"
                className={`w-8 h-8 flex items-center justify-center rounded text-xs font-medium transition-colors cursor-pointer ${
                  indexData.some(item => item.letter === letter)
                    ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                    : 'bg-background-200 text-foreground-400'
                }`}
              >
                {letter}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}